import { useEffect, useState } from 'react';

interface UseThreadAuditStatusParams {
  threadId: string;
  setAuditStatus: (status: MISC.AuditStatus) => void;
}

const useThreadAuditStatus = ({
  threadId,
  setAuditStatus,
}: UseThreadAuditStatusParams) => {
  useEffect(() => {
    const handleApiNotify = (event: Event) => {
      const customEvent = event as CustomEvent;
      const eventData: SSE_EVENT.ThreadAudit = customEvent?.detail;
      if (
        eventData?.event === 'thread_audit' &&
        eventData.thread_id === threadId
      ) {
        const { audit_status } = eventData;
        setAuditStatus(audit_status);
      }
    };

    // Add event listener
    window.addEventListener('api-notify', handleApiNotify as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener(
        'api-notify',
        handleApiNotify as EventListener,
      );
    };
  }, [threadId]);
};

export default useThreadAuditStatus;
